import {getApplyList,selectApplyInfo} from "@/request/apply"

export default {
    namespaced:true,
    state:{
        applylist:[],
        applyinfo:[],
        subjectName:'',
        examAddress:'',
        pageIndex:1,
        pageSize:10
    },
    getters:{
        applylist:(state:any) => state.applylist
    },
    mutations:{
        SET_LIST(state:any,data:any){
            state.applylist = data;
        },
        SET_INFO(state:any,data:any){
            state.applyinfo = data;
        }
    },
    actions:{
        async getApplylist({state,commit}:any,data:any){
            let res = await getApplyList(data);
            console.log("这是列表数据",res)
            // res.data.page.list.forEach((item:any) => {
            // console.log('结束时间',item.applyEndTime,'开始时间',item.applyBeginTime)
             
            // const examtime = new Date(item.applyEndTime).getTime()-new Date(item.applyBeginTime).getTime()

            //  console.log("时间",examtime)
            //  const day:any = Number(examtime/1000/60/60/24)
            //  const hour:any = Number(examtime/1000/60/60%24)
            //  console.log('天',parseInt(day),'小时',parseInt(hour))
            // //  item.time = parseInt(time)
            // //  console.log(item)
            // if(parseInt(day)==0){
            //   item.time =parseInt(hour)+'小时'
            // }else if(parseInt(hour)==0){
            //   item.time = parseInt(day)+'天'
            // }else{
            //   item.time = parseInt(day)+'天'+parseInt(hour)+'小时'  
            // }
            // });
            if(res){
                if(res.data.code == 0){
                    let allArr:any[] = []
                    let teamArr: any[] = []
                    res.data.data.list.forEach((item: any) => {
                        teamArr.push(item)
                        if(item.certificateInfo !==null){
                            teamArr.push(item.certificateInfo[0])
                        }
                        allArr.push(teamArr)
                        teamArr = []
                    });
                    console.log('allArr',allArr)
                    commit('SET_LIST',allArr)
                }
            }
            return res
            // commit("SET_LIST",res.data.page.list)
        },
        async selectApplyInfo({state,commit}:any,data:any){
            const res = await selectApplyInfo(data);
            if(res){
                if(res.data.code == 0){
                    commit('SET_INFO',res.data.sysApplyExam)
                    for(var i=0;i<state.applylist.length;i++){
                    res.data.sysApplyExam.forEach((item:any) => {
                        
                            if(item.examId == state.applylist[i].id){
                                // if(item.applyStatus == 1)
                                state.applylist[i].applyStatus = item.applyStatus;
                                // else{
                                    // state.applylist[i].applyStatus = item.applyStatus;
                                // }
                                return
                            }
                        });
                        }
                    
                }
            }
            // commit("SET_LIST",res.data.page.list)
        },
    }
}